import ApiService from "../../commons/services/ApiService";
import CompanyAPI from '../company/CompanyAPI';

const apiService = new ApiService();

const companyAPI = new CompanyAPI();

export default class WhatsappMetaAPI {

    URI_V1 = "/v1/whatsapp-meta"

    finishConnection = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/finish?companyId=${companyAPI.getCompanyManagment().id}`, data);
    };

}
